import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
  Checkbox,
} from '@mui/material';
import { DataGrid, gridClasses, GridToolbar, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import { lightGreen, red } from '@mui/material/colors';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { toast } from 'react-toastify';

import { useSelector } from 'react-redux';
import { useGetShiftsQuery } from '../../slices/shiftApiSlice';
import {
  useGetShiftRequestsAgencyByAgencyIdQuery,
  useGetShiftRequestAgencyByIdQuery,
   useCreateShiftRequestAgencyMutation,
   useDeleteShiftRequestAgencyMutation,
   useUpdateShiftRequestAgencyStatusMutation,
} from '../../slices/shiftRequestAgencyApiSlice';

import { useLayout } from '../../context/LayoutContext';


// Styled DataGrid with conditional row styles
const StyledDataGrid = styled(DataGrid)`
  & .${gridClasses.row}.lightGreenRow {
    background-color: ${lightGreen[100]};
  }
  & .${gridClasses.row}.redRow {
    background-color: ${red[100]};
  }
     & .${gridClasses.row}.lightOrangeRow {
    background-color: #ffe0b2; /* Light orange */
  }
  & .${gridClasses.row}.greenRow {
    background-color: #c8e6c9; /* Soft green */
  }

  & .${gridClasses.row}.darkGreenRow {
    background-color:rgb(149, 240, 152); /* Dark green */
  }

`;


//____________________________________________________________________________________________________________________________________
const ShiftRequestAgencyScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
const { setFluid } = useLayout();
  const { data: shifts, isLoading: loadingShifts, refetch: refetchShifts } = useGetShiftsQuery();

  // get the agency id from the logged in agency when login is working :  requestedBy,   requestedByName,   requestedByEmail,
 const agencyId = '6847f7da25fcb56616c90021';

  const {
    data: shiftRequestsAgency,
    refetch,
    isLoading: loadingRequests,
  } = useGetShiftRequestsAgencyByAgencyIdQuery(agencyId);
  
const CustomToolbar = () => (
  <div style={{ padding: '0.5rem 1rem' }}>
    <GridToolbarQuickFilter />
  </div>
);
  const [createShiftRequest] = useCreateShiftRequestAgencyMutation();
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);
const [updateShiftRequestStatus] = useUpdateShiftRequestAgencyStatusMutation();
const [reapplyModalOpen, setReapplyModalOpen] = useState(false);
const [cancelledRequestToReapply, setCancelledRequestToReapply] = useState(null);



  const getRowClassName = (params) => {
  const now = new Date();
  const end = new Date(params.row.endDateTime);

  if (end < now) return 'redRow';

  const status = params.row.lineStatus?.toLowerCase();

  switch (status) {
    case 'open':
    case 'on hold':
      return 'lightOrangeRow';

    case 'archived':
    case 'filledbystaff':
    case 'filled':
    case 'complete':
      case 'approved':
      return 'greenRow';

    case 'filledbyagency':
      return 'darkGreenRow';

    case 'cancelled':
      return 'redRow';

    default:
      return 'lightGreenRow';
  }
};

const [confirmModalOpen, setConfirmModalOpen] = useState(false);
const [infoModalOpen, setInfoModalOpen] = useState(false);
const [selectedRequestToCancel, setSelectedRequestToCancel] = useState(null);


  const handleSelectShift = async (shift) => {
  const existingRequestAgency = shiftRequestsAgency?.find(
    (req) => req.shiftId === shift._id
  );

  if (existingRequestAgency) {
    if (existingRequestAgency.lineStatus?.toLowerCase() === 'cancelled') {
      setCancelledRequestToReapply(existingRequestAgency);
      setReapplyModalOpen(true);
    }
    return; // Don't create a new request if one exists
  }

  const newRequestAgency = {
    startDateTime: shift.startDateTime,
    endDateTime: shift.endDateTime,
    hospitalLocationId: shift.hospitalLocationId._id,
    wardDepartmentArea: shift.wardDepartmentArea,
    categoryOfStaff: shift.categoryOfStaff,
    requestedBy: userInfo._id,
    requestedByName: userInfo.name,
    requestedByEmail: userInfo.email,
    shiftId: shift._id,
    agencyId: agencyId    // change this to loged in agency when ready  
  };
//console.log("in handleSelectShift-: newRequest ", newRequest)
  try {
    await createShiftRequest(newRequestAgency).unwrap();
    refetch();
    refetchShifts();
  } catch (err) {
    console.error(err);
  }
};


  const [deleteShiftRequestAgency] = useDeleteShiftRequestAgencyMutation();

  const shiftColumns = [
    {
      field: 'select',
      headerName: '',
      width: 60,
      renderCell: (params) => (
        <Checkbox
          checked={selectedShiftIds.includes(params.row._id)}
          onChange={() => {
            handleSelectShift(params.row);
            setSelectedShiftIds([...selectedShiftIds, params.row._id]);
          }}
        />
      ),
    },
    {
      field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
       type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.startDateTime).toLocaleString(),
       valueGetter: (params) => {
    const value = params.row?.startDateTime;
    return value ? new Date(value) : null;
  },
  //valueFormatter: (params) => new Date(params.value).toLocaleString(),
 valueFormatter: (params) => {
    return params.value ? new Date(params.value).toLocaleString() : '';
  },

    },
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
       type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
       valueGetter: (params) => {
    const value = params.row?.endDateTime;
    return value ? new Date(value) : null;
  },
  //valueFormatter: (params) => new Date(params.value).toLocaleString(),
   valueFormatter: (params) => {
    return params.value ? new Date(params.value).toLocaleString() : '';
  },

    },
    { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 180 },
    { field: 'lineStatus', headerName: 'Status', width: 150 },
    { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
  ];

  const requestColumns = [

    {
    field: 'remove',
    headerName: 'Remove',
    width: 60,
    renderCell: (params) => (
  <Checkbox
    color="error"
    onChange={() => {
      const request = params.row;
      if (request.lineStatus?.toLowerCase() === 'shiftrequested') {
        setSelectedRequestToCancel(request);
        setConfirmModalOpen(true);
      } else {
        setInfoModalOpen(true);
      }
    }}
  />
),

  },
    {
      field: 'startDateTime',
      headerName: 'Start Time',
      width: 180,
      type: 'dateTime',
        valueGetter: (params) => new Date(params.row.startDateTime),
        valueFormatter: (params) => new Date(params.value).toLocaleString(),
},
    
    {
      field: 'endDateTime',
      headerName: 'End Time',
      width: 180,
      type: 'dateTime',
      //valueGetter: (params) => new Date(params.row.endDateTime).toLocaleString(),
      valueGetter: (params) => new Date(params.row.endDateTime),
  valueFormatter: (params) => new Date(params.value).toLocaleString(),

    },
    { field: 'wardDepartmentArea', headerName: 'Ward/Dept Area', width: 180 },
    { field: 'categoryOfStaff', headerName: 'Staff Category', width: 150 },
    { field: 'lineStatus', headerName: 'Status', width: 150 },
  ];


  useEffect(() => {
        // Enable full-width container
        setFluid(true);
    
        return () => {
          // Reset back to normal when screen unmounts
          setFluid(false);
        };
      }, [setFluid]);
    

 //___________________________________________________________________________________________________________________________________________     
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" mb={2}>Agency Shift Request Panel</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" mb={1}>Available Shifts</Typography>
          {loadingShifts ? (
            <CircularProgress />
          ) : (
            <StyledDataGrid
      density="compact"
              rows={shifts?.filter((s) => !s.stage1Approval) || []}
              columns={shiftColumns}
              getRowId={(row) => row._id}
              getRowClassName={getRowClassName}
              autoHeight
              pageSize={10}
               slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
               sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
               
            />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6" mb={1}>Your Shift Requests</Typography>
          {loadingRequests ? (
            <CircularProgress />
          ) : (
            <StyledDataGrid
      density="compact"
              rows={shiftRequestsAgency || []}
              columns={requestColumns}
              getRowId={(row) => row._id}
              getRowClassName={getRowClassName}
              autoHeight
              pageSize={10}
              slots={{ toolbar: CustomToolbar }}  // ⬅️ Use your custom toolbar here
              sortModel={[{ field: 'startDateTime', sort: 'desc' }]} // <-- Add this
            />
          )}
        </Grid>
      </Grid>

      {/* Confirm Cancel Modal */}
<Dialog open={confirmModalOpen} onClose={() => setConfirmModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Cancel Shift Request
    </Typography>
    <Typography>
      Are you sure you want to cancel this shift request?
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
      <Button onClick={() => setConfirmModalOpen(false)}>No</Button>
      <Button
        color="error"
        variant="contained"
        onClick={async () => {
          try {
            
            await updateShiftRequestStatus({
        shiftRequestId: selectedRequestToCancel._id,
        lineStatus: "Cancelled",
      }).unwrap();


            refetch();
            setConfirmModalOpen(false);
          } catch (err) {
            console.error('Failed to cancel shift request:', err);
          }
        }}
      >
        Yes, Cancel
      </Button>
    </Box>
  </Box>
</Dialog>

{/* Info Modal */}
<Dialog open={infoModalOpen} onClose={() => setInfoModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Cannot Cancel Request
    </Typography>
    <Typography>
      This shift has already been assigned. Please speak to your manager if you need to cancel it.
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end">
      <Button onClick={() => setInfoModalOpen(false)} variant="contained">OK</Button>
    </Box>
  </Box>
</Dialog>

<Dialog open={reapplyModalOpen} onClose={() => setReapplyModalOpen(false)}>
  <Box p={3}>
    <Typography variant="h6" gutterBottom>
      Reapply for Shift
    </Typography>
    <Typography>
      You've previously cancelled this shift. Do you want to reapply?
    </Typography>
    <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
      <Button onClick={() => setReapplyModalOpen(false)}>No</Button>
      <Button
        variant="contained"
        onClick={async () => {
          try {
            await updateShiftRequestStatus({
              shiftRequestId: cancelledRequestToReapply._id,
              lineStatus: 'shiftRequested',
            }).unwrap();

            toast.success('Shift request re-applied!');
            refetch();
            refetchShifts();
            setReapplyModalOpen(false);
          } catch (err) {
            console.error('Failed to reapply for shift:', err);
            toast.error('Error reapplying for shift');
          }
        }}
      >
        Yes, Reapply
      </Button>
    </Box>
  </Box>
</Dialog>


    </Box>
  );
};



export default ShiftRequestAgencyScreen;
